module.exports = __webpack_public_path__ + "img/Tao_Mei@2x.27ccc0a5.png";